import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetPartnersTableHtmlProps = {
  societyId: string;
  language: string;
};

export const getPartnersTableHtml =
  ({ societyId, language }: GetPartnersTableHtmlProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/societies/partners-table', {
        params: { societyId, language },
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
